//
// Strongly typed interfaces for the API's standard JSON responses
//

export enum ResultType {
    Ok = "Ok",
    NotFound = "NotFound",
    NoSeat = "NoSeat",
    InsufficientPermissions = "InsufficientPermissions",
    Failure = "Failure",
    Forbidden = "Forbidden",
    QuotaExceeded = "QuotaExceeded",
    NetworkFailure = "NetworkFailure",
    UploadTooLarge = "UploadTooLarge"
}

export interface ApiResponse {
    result: ResultType | string;
    resultMessage?: string;
}

export interface ApiDataResponse<TData> extends ApiResponse {
    data: TData | null;
}
